
// UserManagerAccess
// ViewForAccess

export default class UserManager {

    public userId           : ID
    public manageRelations  : any   // ??

    constructor(userId?: ID, manageRelations?:any) {

        // manageRelations: [{
        //     companyId: "PGUOPE"
        //     momentCreated: "2018-05-03T13:10:25.50604"
        //     targetUserId: "9V5f4g"                       //manager for userId
        //     userId: "6h9Lee"                             //user to manage
        // }, ...]

        this.userId             = userId ? userId : gd.user.id
        this.manageRelations    = manageRelations ? manageRelations : gd.session.workScheduleAccess.models
    }

    getManagerForUsersIds(companyId? : ID, addCurrentUser : boolean = true) {

        if (!companyId) companyId = gd.companyId

        //get ids of users current user can change tasks schedule for
        let res = _.chain(this.manageRelations)
            .filter(wsa=>wsa.targetUserId === this.userId && (!companyId || wsa.companyId === companyId))
            .map(wsa=>wsa.userId)
            .uniq()
            .value();

        //add current user as first item in array
        if (addCurrentUser && this.userId) res.unshift(this.userId);

        return res;
    }

    isManagerForUser(userId:ID) {
        // console.log("isManagerForUser check if user", this.userId, "has access to ", userId)

        return !!_.find(this.manageRelations, wsa=>wsa.userId === userId && wsa.targetUserId === this.userId);
    }

    getManagedByUserIds() {
        //get ids of users who can change tasks schedule for current user
        return _.chain(this.manageRelations)
            .filter(wsa=>wsa.userId === this.userId)
            .map(wsa=>wsa.targetUserId)
            .uniq()
            .value();
    }
}